module.exports = __webpack_public_path__ + "static/media/Cartela_V_gris.a6c6c51c.svg";